module.exports = __webpack_public_path__ + "static/Adapt_with_Ease-4fc1d8806aec5f925e416afaa6ee2fbc.png";